module.exports = __webpack_public_path__ + "static/img/header_logo.6319b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_logo.png
// module id = oHgo
// module chunks = 9